import React, { PureComponent } from 'react';
import { compose } from 'recompose';
import PropTypes from 'prop-types';
import { EventFilterUI } from './ui';

export class EventFilter extends PureComponent {
    static displayName = 'EventFilterContainer';

    static propTypes = {
        onChange: PropTypes.func,
        name: PropTypes.string,
        value: PropTypes.shape({
            type: PropTypes.string,
            operator: PropTypes.string,
            value: PropTypes.any
        })
    };

    static defaultProps = {
        onChange: undefined,
        name: 'eventFilter',
        value: null
    };

    render() {
        const { name, value, onChange } = this.props;
        return <EventFilterUI value={value} onChange={onChange} name={name} />;
    }
}

export const EventFilterContainer = compose()(EventFilter);
